<template>
  <label :class="classes">
    <input
      v-model="computedValue"
      @click.stop
      @change="onChange"
      :name="name"
      type="checkbox"
      class="checkbox__field"
      :value="nativeValue"
      :true-value="trueValue"
      :false-value="falseValue"
      :disabled="$attrs.disabled"
      :autocomplete="autocomplete"
    />
    <span :class="labelClasses">
      <slot></slot>
    </span>
  </label>
</template>

<script>
import CheckRadioMixin from "../../../utils/CheckBoxRadioMixin.js";
import callExternalFunction from "../../../utils/callExternalFunction";

export default {
  name: "M4Checkbox",
  mixins: [CheckRadioMixin, callExternalFunction],
  data() {
    return {
      newValue: this.modelValue ? this.modelValue : this.value
    };
  },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    trueValue: {
      type: [String, Number, Boolean, Function, Object, Array],
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean, Function, Object, Array],
      default: false
    },
    autocomplete: {
      type: String,
      default() {
        return "on";
      }
    }
  },
  emits: ["change"],
  computed: {
    classes() {
      return ["checkbox"];
    },
    labelClasses() {
      let classes = ["checkbox__label"];
      if (this.error) {
        classes.push("checkbox__label--error");
      }
      if (this.isDisabled) {
        classes.push("checkbox__label--disabled");
      }
      return classes;
    },
    isDisabled() {
      return this.$attrs.disabled !== undefined && this.$attrs.disabled;
    }
  },
  methods: {
    onChange(event) {
      this.$emit("change", event.target);
      this.callExtFunc("change", event.target);
    }
  },
  watch: {
    /**
     * When v-model is changed:
     *   1. Set internal value.
     */
    modelValue(value) {
      this.newValue = value;
    },
    value(value) {
      this.newValue = value;
    }
  }
};
</script>
